const ARROW_RIGHT_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 5.53642C8.68342 5.1459 9.31658 5.1459 9.70711 5.53642L15.7071 11.5364C16.0976 11.9269 16.0976 12.5601 15.7071 12.9506L9.70711 18.9506C9.31658 19.3412 8.68342 19.3412 8.29289 18.9506C7.90237 18.5601 7.90237 17.9269 8.29289 17.5364L13.5858 12.2435L8.29289 6.95064C7.90237 6.56011 7.90237 5.92695 8.29289 5.53642Z" stroke="none"/>
</svg>`;

export default ARROW_RIGHT_ICON;
